var map = {
	"./WorkerBlue-v2.png": 3288,
	"./WorkerGreen-v2.png": 7884,
	"./WorkerPurple-v2.png": 7152,
	"./WorkerRed-v2.png": 884,
	"./WorkerYellow-v2.png": 5200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2491;